import { ViewerEventType } from '../types/ViewerEvents.type';
export class AssetViewerItemPresentationsPreloaderService {
    constructor(assetViewerItems, eventBus) {
        this.assetViewerItems = assetViewerItems;
        this.eventBus = eventBus;
        this.onViewerViewRendered = (event) => {
            const currentIndex = this.assetViewerItems.findIndex(item => item.id === event.payload.assetViewerView.id);
            const next = this.assetViewerItems[currentIndex + 1];
            if (next && !next.presentations) {
                next.loadPresentations().catch(e => console.warn('loadPresentations() failed', e));
            }
        };
    }
    init() {
        if (this.assetViewerItems.find(assetViewerItem => !assetViewerItem.presentations)) {
            this.addEventListeners();
        }
    }
    addEventListeners() {
        this.eventBus.on(ViewerEventType.ViewRendered, this.onViewerViewRendered);
    }
    removeEventListeners() {
        this.eventBus.off(ViewerEventType.ViewRendered, this.onViewerViewRendered);
    }
    destroy() {
        this.removeEventListeners();
    }
}
//# sourceMappingURL=asset-viewer-item-presentations-preloader.service.js.map